import { apiClient } from "../../../lib/apiClient";
import type { ApiResponse } from "../../../types/apiResponse";
import type { UploadQuoteData } from "../types";

export const createQuote = (payload: UploadQuoteData) => {
   return apiClient<ApiResponse>("/v1/quote", {
      method: "POST",
      body: payload
   })
}
